const dairy = [];
dairy.push(
    "chocolate milk",
    "coconut milk",
    "milk"
);

export default dairy;